// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutoSaveController from "./auto_save_controller";

application.register("auto-save", AutoSaveController);

import AutoSubmitController from "./auto_submit_controller";

application.register("auto-submit", AutoSubmitController);

import CarouselController from "./carousel_controller";

application.register("carousel", CarouselController);

import DialogController from "./dialog_controller";

application.register("dialog", DialogController);

import DisableFormController from "./disable_form_controller";

application.register("disable-form", DisableFormController);

import DocusealController from "./docuseal_controller";

application.register("docuseal", DocusealController);

import DropdownController from "./dropdown_controller";

application.register("dropdown", DropdownController);

import GalleryController from "./gallery_controller";

application.register("gallery", GalleryController);

import InpostController from "./inpost_controller";

application.register("inpost", InpostController);

import RadioController from "./radio_controller";

application.register("radio", RadioController);

import RefreshController from "./refresh_controller";

application.register("refresh", RefreshController);

import WygodneZwrotyController from "./wygodne_zwroty_controller";

application.register("wygodne-zwroty", WygodneZwrotyController);
